module.exports = __webpack_public_path__ + "static/img/rest11.ddbc0b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest11.jpg
// module id = KfQi
// module chunks = 0